import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SET_ADMIN } from "./store/admin/types";

import Admin from "./pages/Admin";
import HostHistory from "./pages/HostHistory";
import HostHistoryInfo from "./pages/HostHistoryInfo";
import LanguageSwitcher from "./LanguageSwitcher/LanguageSwitcher";
import AccessGuard from "./component/AccessGuard";

const STORAGE_KEY = "selectedLanguageCode";

function App() {
  const dispatch = useDispatch();
  const token = localStorage.getItem("TOKEN");
  const key = localStorage.getItem("KEY");

  const params = new URLSearchParams(window.location.search);

  // The ?id= access link is persisted by <AccessGuard>; reading it again here
  // would re-write the literal string "null" into storage on a bare visit.
  const urlLanguage = params.get("language")?.trim()?.toLowerCase();
  if (urlLanguage) {
    localStorage.setItem(STORAGE_KEY, urlLanguage);
  }

  useEffect(() => {
    if (!token && !key) return;
    dispatch({ type: SET_ADMIN, payload: token });
  }, [token, key, dispatch]);

  return (
    <div className="App">
      <LanguageSwitcher />
      {/* ponytail: portals are handed out as per-host links, so an id-less visit
          is blocked here rather than left to 500 its way through the dashboard. */}
      <AccessGuard>
        <Suspense fallback={""}>
          <BrowserRouter>
            <Routes>
              <Route path="/host/homePage" element={<Admin />} />
              <Route path="/host/hosthistory" element={<HostHistory />} />
              <Route path="/host/historyInfo" element={<HostHistoryInfo />} />
              <Route path="*" element={<Navigate to="/host/homePage" />} />
            </Routes>
          </BrowserRouter>
        </Suspense>
      </AccessGuard>
    </div>
  );
}

export default App;
